<template>
  <div class="highlight-card-container">
    <div class="card highlight-card">
      <!-- Video Player -->
      <div class="video-wrapper">
        <LazyVideoPlayer v-if="highlight.videoId"
                         :videoUrl="`https://www.youtube.com/embed/${highlight.videoId}`"
                         :videoId="highlight.videoId"
                         :title="highlight.title" />
      </div>

      <!-- Content Section -->
      <div class="highlight-content">
        <h3 class="highlight-title">{{ highlight.title }}</h3>
<!--        <p class="highlight-location">{{ highlight.location }}</p>-->
<!--        <div class="highlight-description" v-html="highlight.subTitle"></div>-->
        <div class="highlight-details" v-html="highlight.content"></div>

<!--        <router-link v-if="highlight.link" :to="highlight.link" class="cta-btn">-->
<!--          View Event Details-->
<!--        </router-link>-->
      </div>

      <!-- Navigation Controls -->
      <div class="navigation-controls">
        <button class="nav-btn" @click="activeIdx--" :disabled="activeIdx === 0">
          &#8592; Prev
        </button>
        <span class="nav-counter">{{ activeIdx + 1 }} / {{ highLightConfig.length }}</span>
        <button class="nav-btn" @click="activeIdx++" :disabled="activeIdx === highLightConfig.length - 1">
          Next &#8594;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// NOTE: LazyVideoPlayer component code is assumed to be in its own file
// and is not included here, as no changes were needed for it.
import LazyVideoPlayer from "@/components/LazyVideoPlayer/LazyVideoPlayer";

export default {
  name: 'HighLightCard',
  components: {
    LazyVideoPlayer,
  },
  data() {
    return {
      activeIdx: 0,
      // This configuration can be moved to a prop or a separate file for better reusability
      highLightConfig: [
        {
          title: "SAINTE VIE Live",
          location: 'Zamna Tulum',
          subTitle: "<p><strong>#MexicanHero</strong><br>An immersive journey of musical storytelling.</p>",
          content: "<p>A key player in Zamna's closing festivities, Sainte Vie delivers an epic and essential Tulum soundscape.</p>",
          link: '/event/closing-party-zamna-tulum-february-2024',
          videoId: 'mSOXgy0SRvI'
        },
        {
          title: "Anyma & Chris Avantgarde - Eternity",
          location: 'Live from Afterlife Tulum',
          subTitle: "<p><strong>Anyma: Genesys</strong><br>Experience the new era of audiovisual performance.</p>",
          content: "<p>A stunning visual and auditory spectacle from one of Afterlife's most iconic sets at Zamna Festival.</p>",
          link: '/brands/afterlife-tulum',
          videoId: '82-5u3H1-yk'
        },
        {
          title: "Armen Miran @ SET Underground",
          location: 'Tulum Jungle',
          subTitle: "<p><strong>SET Underground</strong><br>The authentic Tulum jungle rave experience.</p>",
          content: "<p>Dive into the deep, mystical vibes of a true jungle party with SET Underground's signature sound.</p>",
          link: '/brands/set-underground-tulum',
          videoId: 'QkniYaPbePQ',
        },
        {
          title: "BLOND:ISH Sunrise Mix",
          location: 'Papaya Playa Project',
          subTitle: "<p><strong>Storytellers presents BLOND:ISH</strong><br>An institution on the global dance arena.</p>",
          content: "<p>Catch the magical energy of a sunrise set at one of Tulum's most legendary beach clubs.</p>",
          link: '/tulum-clubs/papaya-playa',
          videoId: '3XFzRrUYlwY'
        },
        {
          title: "DAMIAN LAZARUS Sunrise Set",
          location: 'DAY ZERO FESTIVAL',
          subTitle: "<p><strong>Day Zero</strong><br>The master of ceremonies at the dawn of a new day.</p>",
          content: "<p>A journey through sound from the founder of Day Zero, one of the world's most unique festival experiences.</p>",
          link: '/brands/day-zero-tulum',
          videoId: 'nF1UIC6chjw'
        },
        {
          title: "Claptone - The Masquerade",
          location: 'Zamna Tulum',
          subTitle: "<p><strong>Claptone's Full Set</strong><br>The enigmatic artist's iconic Tulum performance.</p>",
          content: "<p>Relive the magic of The Masquerade, streamed live from the heart of Zamna's jungle amphitheater.</p>",
          link: '/brands/zamna-tulum',
          videoId: 'ty5JWlPTFCU'
        },
        {
          title: "Michael Bibi @ Bonbonniere 2022",
          videoId: 'vKZmKy3BPjM'
        },
        {
          title: "Mathame @ Zamna Afterlife 2020",
          videoId: 'YLT7i0oK6UM'
        },
        {
          title: 'Solomun | Boiler Room: Tulum PPP - 2015',
          videoId: 'bk6Xst6euQk'

        }
      ]
    };
  },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
  },
  computed: {
    highlight() {
      return this.highlightList[this.activeIdx] || {};
    },
    highlightList() {
      return this.shuffleArray(this.highLightConfig)|| {};
    }
  },
};
</script>

<style scoped>
.highlight-card-container {
  font-family: Arial, sans-serif;
}

.highlight-card {
  background-color: #252528;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #444;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.video-wrapper {
  width: 100%;
  background-color: #000;
}

.highlight-content {
  padding: 1.5rem;
  text-align: left;
}

.highlight-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 0.25rem 0;
}

.highlight-location {
  font-size: 0.9rem;
  color: #00c6ff;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.highlight-description,
.highlight-details {
  font-size: 1rem;
  line-height: 1.6;
  color: #ccc;
}
/* Deep selector to style content from v-html */
.highlight-details >>> a,
.highlight-description >>> a {
  color: #00c6ff;
  text-decoration: none;
  font-weight: bold;
}

.cta-btn {
  display: inline-block;
  margin-top: 1.5rem;
  background-color: #00c6ff;
  color: #1a1a1c;
  padding: 0.7rem 1.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  text-align: center;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.cta-btn:hover {
  background-color: #fff;
  transform: translateY(-2px);
}

.navigation-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: #1f1f21;
  border-top: 1px solid #444;
}

.nav-btn {
  background-color: #3a3a3c;
  color: #f0f0f0;
  border: 1px solid #555;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s ease;
}

.nav-btn:hover:not(:disabled) {
  background-color: #4a4a4c;
}

.nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-counter {
  font-size: 0.9rem;
  font-weight: 700;
  color: #aaa;
}
</style>
